import { Component } from '@angular/core';
import { NewsServiceService } from 'src/app/service/news-service.service';
import { PostsService } from 'src/app/service/posts.service';

@Component({
  selector: 'app-view-all-posts',
  templateUrl: './view-all-posts.component.html',
  styleUrl: './view-all-posts.component.scss'
})
export class ViewAllPostsComponent {

   singleBlogPost:any;
      constructor(private postsService: PostsService) {
          this.postsService.getAllDetails().subscribe(res=>{
              this.singleBlogPost = res;
          })
       }
  
      ngOnInit(): void {
          
      }
  
      sectionTitle = [
          {
              title: "Our Latest Posts",
            //  paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida."
          }
      ]

}
